import React from "react";
import Button from "@source/components/UI/buttons/button/button";
import ConfirmModal from "@source/components/confirmModal/confirmModal";
import styles from "./consentSteps.module.scss";

export const StepFooter = ({error, stageLabel, disabled, onCancel, onContinue, continueDisabled, onSave, onDelete, deleting, onSend, saving, sending}: {
  error: string;
  stageLabel?: string;
  disabled: boolean;
  onCancel: () => void;
  onContinue?: () => void;
  continueDisabled?: boolean;
  onSave?: () => void;
  onDelete?: () => void;
  deleting?: boolean;
  onSend?: () => void;
  saving?: boolean;
  sending?: boolean;
}) => {
  const deleteDraft = onDelete ? <ConfirmModal title="Are you sure you want to delete the consent draft?" confirmCb={onDelete} confirmLoading={deleting}>
    <Button size="small" variant="outlined" className={styles.leftBtn} disabled={disabled}>Delete</Button>
  </ConfirmModal> : null;
  return <div className={styles.actions}>
  {error ? <p className={styles.error} role="alert">{error}</p> : null}
  {stageLabel ? <p className={styles.stage} role="status">{stageLabel}</p> : null}
  <div className={styles.actionButtons}>
    <div className={styles.actionGroup}>
      <Button size="small" variant="outlined" className={styles.leftBtn} onClick={onCancel} disabled={disabled}>Cancel</Button>
      {deleteDraft}
    </div>
    {onContinue ? <div className={styles.actionGroup}>
      {onSave ? <Button size="small" variant="additional" className={styles.leftBtn} onClick={onSave} disabled={disabled} isLoading={saving}>Save as draft</Button> : null}
      <Button size="small" className={styles.leftBtn} onClick={onContinue} disabled={disabled || continueDisabled}>Continue</Button>
    </div> : <div className={styles.actionGroup}>
      <Button size="small" variant="additional" className={styles.leftBtn} onClick={onSave} disabled={disabled} isLoading={saving}>Save as draft</Button>
      <Button size="small" className={styles.leftBtn} onClick={onSend} disabled={disabled} isLoading={sending}>Send</Button>
    </div>}
  </div>
</div>;
};
